import { Component, Input, OnInit } from '@angular/core';
import { ContactHelper } from 'src/app/helpers/contact-helper';
import ProjectHelper from 'src/app/helpers/project-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Project } from 'src/app/model/project/project';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { SubProject } from 'src/app/model/project/sub-project';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { PrintAddressPipe } from 'src/app/pipes/print-address.pipe';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'placement-card-appointment-info',
  templateUrl: './placement-card-appointment-info.component.html',
  styleUrls: ['./placement-card-appointment-info.component.scss'],
  providers: [FormatPhoneNumber, PrintAddressPipe],
})
export class PlacementCardAppointmentInfoComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  projectPlacement: ProjectPlacement;

  @Input()
  project?: Project;

  @Input()
  subProject: SubProject;

  appointmentContactInfoDisplay: string;
  appointmentWithCustomerDisplay: string;
  appointmentCollectKeyFromDisplay: string;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private formatPhoneNumber: FormatPhoneNumber,
    private printAddressPipe: PrintAddressPipe
  ) {
    super();
  }

  ngOnInit(): void {
    this.calculateAppointmentContactInfoDisplay();
    this.calculateAppointmentWithCustomerDisplay();
    this.calculateAppointmentCollectKeyFromDisplay();
    this.initializeSubscriptions();
  }

  private initializeSubscriptions(): void {
    this.addSubscription(
      this.projectDisplayObservableService.getProjectPlacementVariableChangedSubscribable(),
      () => {
        this.calculateAppointmentContactInfoDisplay();
        this.calculateAppointmentWithCustomerDisplay();
        this.calculateAppointmentCollectKeyFromDisplay();
      }
    );
  }

  private calculateAppointmentContactInfoDisplay(): void {
    if (this.projectPlacement.appointmentContact == null) {
      this.appointmentContactInfoDisplay = null;
    } else {
      if (
        (StringHelper.isEmpty(
          this.projectPlacement.appointmentContact['phoneNumber']
        ) &&
          this.projectPlacement.appointmentContact.phoneNumberDisplay ==
            null) ||
        (StringHelper.isEmpty(
          this.projectPlacement.appointmentContact['mobileNumber']
        ) &&
          this.projectPlacement.appointmentContact.mobileNumberDisplay ==
            null) ||
        (StringHelper.isEmpty(
          this.projectPlacement.appointmentContact['email']
        ) &&
          this.projectPlacement.appointmentContact.emailDisplay == null)
      ) {
        ContactHelper.setFormDisplays(
          this.projectPlacement.appointmentContact,
          this.formatPhoneNumber
        );
      }
      this.appointmentContactInfoDisplay = StringHelper.join(
        [
          StringHelper.join(
            [
              this.projectPlacement.appointmentContact.firstName,
              this.projectPlacement.appointmentContact.lastName,
            ],
            ' '
          ),
          StringHelper.isEmpty(
            this.projectPlacement.appointmentContact['phoneNumber']
          )
            ? this.projectPlacement.appointmentContact.phoneNumberDisplay
            : this.projectPlacement.appointmentContact['phoneNumber'],
          StringHelper.isEmpty(
            this.projectPlacement.appointmentContact['mobileNumber']
          )
            ? this.projectPlacement.appointmentContact.mobileNumberDisplay
            : this.projectPlacement.appointmentContact['mobileNumber'],
          StringHelper.isEmpty(
            this.projectPlacement.appointmentContact['email']
          )
            ? this.projectPlacement.appointmentContact.emailDisplay
            : this.projectPlacement.appointmentContact['email'],
        ],
        ' - '
      );
    }
  }

  private calculateAppointmentWithCustomerDisplay(): void {
    this.appointmentWithCustomerDisplay = StringHelper.join(
      [
        this.projectPlacement.appointmentName,
        this.projectPlacement.appointmentPhoneNumber,
        this.projectPlacement.appointmentEmail,
      ],
      ' - '
    );
  }

  private calculateAppointmentCollectKeyFromDisplay(): void {
    if (!this.projectPlacement.collectKey) {
      this.appointmentCollectKeyFromDisplay = null;
      return;
    }
    if (
      this.projectPlacement.collectKeyFrom == null ||
      this.projectPlacement.collectKeyFrom < 1
    ) {
      this.appointmentCollectKeyFromDisplay =
        this.projectPlacement.collectKeyExtraInfo;
    } else {
      let address = <any>(
        ProjectHelper.getKeyCollectionAddress(this.subProject, this.project)
      );
      address =
        address != null && address.address != null ? address.address : address;

      this.appointmentCollectKeyFromDisplay =
        address == null
          ? null
          : this.printAddressPipe.transform(
              address.line1,
              address.postalCode,
              address.city
            );
    }
  }
}
